import { gql } from '@apollo/client';

export const CREATE_ASSESSMENT = gql`
  mutation insert_assessment($objects: [assessment_insert_input!]!) {
    insert_assessment(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPDATE_ASSESSMENT = gql`
  mutation update_assessment($where: assessment_bool_exp!, $_set: assessment_set_input) {
    update_assessment(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const ASSESSMENT = gql`
  query assessment($where: assessment_bool_exp) {
    assessment(where: $where) {
      title
      startDate
      endDate
      description
      id
      isUploadable
      resources
      totalMarks
      student_assessment_submissions {
        id
        uploadURLs
        created_at
        student {
          firstName
          lastName
          sliitID
          waiID
          regNumber
        }
      }
      batch_subject_configuration {
        course_semester {
          course {
            name
          }
        }
        batch {
          name
        }
        subject {
          name
        }
      }
    }
  }
`;

export const ASSESSMENT_RESOURCES_UPLOAD_URLS = gql`
  query assessmentResourcesUploadURLs($data: AssessmentResourcesUploadURLsInput!) {
    assessmentResourcesUploadURLs(data: $data) {
      id
      url
    }
  }
`;

export const DELETE_ASSESSMENT = gql`
  mutation delete_assessment($where: assessment_bool_exp!) {
    delete_assessment(where: $where) {
      affected_rows
    }
  }
`;

export const ASSESSMENTS = gql`
  subscription assessments($where: assessment_bool_exp, $order_by: [assessment_order_by!]) {
    assessment(where: $where, order_by: $order_by) {
      endDate
      id
      batch_subject_configuration {
        batch {
          name
          id
          course {
            id
            name
          }
        }
        subject {
          id
          name
        }
      }
      startDate
      title
    }
  }
`;

export const STUDENT_ASSESSMENTS = gql`
  subscription studentAssessments($where: assessment_bool_exp, $order_by: [assessment_order_by!]) {
    assessment(where: $where, order_by: $order_by) {
      endDate
      id
      description
      startDate
      title
      resources
      isUploadable
      student_assessment_submissions{
        uploadURLs
      }
      batch_subject_configuration {
        batch {
          name
          id
          course {
            id
            name
          }
        }
        subject {
          id
          name
        }
      }
    }
  }
`;

export const STUDENT_ASSESSMENT_SUBMISSIONS = gql`
  subscription student_assessment_submissions(
    $where: student_assessment_submission_bool_exp
    $order_by: [student_assessment_submission_order_by!]
  ) {
    student_assessment_submission(where: $where, order_by: $order_by) {
      id
      assessmentId
    }
  }
`;

export const STUDENT_ASSESSMENT_SUBMISSION_UPLOAD_URLS = gql`
  query studentAssessmentSubmissionUploadsURLs($data: StudentAssessmentSubmissionUploadURLsInput!) {
    studentAssessmentSubmissionUploadsURLs(data: $data) {
      id
      url
    }
  }
`;

export const CREATE_STUDENT_ASSESSMENT_SUBMISSION = gql`
  mutation createStudentAssessmentSubmission($data: CreateStudentAssessmentSubmissionInput!) {
    createStudentAssessmentSubmission(data: $data) {
      studentAssessmentSubmissionId
    }
  }
`;
